import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Switch from 'component/Layout/Form/Switch';

import { getDestinationId } from 'pages/hotels/context/__helper/tracking';

import classNames from 'classnames';
import { Feature } from 'config/features';
import { useAtomValue } from 'jotai';

import { useFeature } from 'hooks/useFeature';

import { destinationAtom } from 'data/Atom/Search';

import Map from 'media/img/general/map.png';
import { ReactComponent as IconLocationPin } from 'media/svg/locationPin.svg';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';
import { hasUrlParam } from 'utility/Provide/Url';
import { trackGa4Event } from 'utility/Track/trackingHelper';

import styles from '../Header.module.scss';

const hasSemBadge = hasUrlParam('semBadge');
const body = document.querySelector('.split-view');

const MapToggle = () => {
    const { t } = useTranslation();
    const splitMapOpen = useFeature(Feature.SplitMapInitiallyOpened);
    const { react } = useContext(CommunicationContext);
    const [checked, setChecked] = useState(splitMapOpen && !hasSemBadge);
    const toggleMap = useCallback((value: boolean) => setChecked(value), []);
    const destination = useAtomValue(destinationAtom);
    const destinationId = getDestinationId(destination);

    react.dispatch('event-map-toggle-ready', {});

    useEffect(() => {
        react.bind('toggleMap', toggleMap);

        return () => {
            react.unbind('toggleMap', toggleMap);
        };
    }, [react, toggleMap]);

    return (
        <div
            className={classNames(
                styles.MapToggle,
                'js-sticky-layer-location-main-map',
                'c24-ads-sky-pos',
                'show-map'
            )}
            data-show-map="show-map-hotels"
            data-region-id={destinationId}
            data-region-name={destination.label}
            onClick={() => setChecked((current) => !current)}
        >
            <div
                className={styles.MapImg}
                onClick={() => {
                    trackGa4Event('map_click_open', {
                        click_position: 'mapSnippet',
                        region_id: destinationId,
                        region_name: destination.label,
                    });
                }}
            >
                <img
                    src={Map}
                    width="100%"
                    height="36"
                    alt={t('TRANS-show-map')}
                />
                <IconLocationPin />
            </div>
            <div>
                <span
                    onClick={() => {
                        trackGa4Event('map_click_open', {
                            click_position: 'mapSnippetLink',
                            region_id: destinationId,
                            region_name: destination.label,
                        });
                    }}
                >
                    {t('TRANS-show-map')}
                </span>
                <Switch
                    customClass={{
                        Wrapper: 'js-switch-toggle',
                        Input: classNames('js-switch-toggle-checkbox', {
                            'js-user-close': body?.classList.contains(
                                'js-user-map-toggle-off'
                            ),
                        }),
                    }}
                    isActive={checked}
                />
            </div>
        </div>
    );
};
export default MapToggle;
